export { ProductCardsContainer as ProductBlock } from './ui/ProductCardsContainer/ProductCardsContainer';
